module.exports = __webpack_public_path__ + "static/media/google_preferred_source_badge_dark.1b57cd82.png";